"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cgpToHumanizedShort = void 0;
function getNode(data, nodeIdx, num_in) {
    if (nodeIdx < num_in) {
        return `Input${nodeIdx}`;
    }
    const idxL = parseInt(data[(nodeIdx - num_in) * 3]);
    const idxR = parseInt(data[(nodeIdx - num_in) * 3 + 1]);
    const operation = data[(nodeIdx - num_in) * 3 + 2];
    //return `(getNode(data, ${idxL}, num_in)} ${operation} getNode(data, ${idxL}, num_in))`;
    return `(${getNode(data, idxL, num_in)} ${operation} ${getNode(data, idxR, num_in)})`;
}
function cgpToHumanizedShort(program, num_in, num_mid, num_out) {
    const data = program.split(" ");
    const output = new Array();
    for (let i = 0; i < num_out; i++) {
        const ptr = data[i + num_mid * 3];
        const nodeStr = `Output #${i}: ${getNode(data, parseInt(ptr), num_in)}`;
        output.push(nodeStr);
    }
    return output.join("\n");
}
exports.cgpToHumanizedShort = cgpToHumanizedShort;
function cgpToHumanizedFull(program, num_in, num_mid, num_out) {
    const data = program.split(" ");
    const output = new Array();
    for (let i = 0; i < num_in; i++) {
        const nodeStr = `Input #${i}`;
        output.push(nodeStr);
    }
    for (let i2 = 0; i2 < num_mid; i2++) {
        const idx = i2 + num_in;
        const idxL = data[i2 * 3];
        const idxR = data[i2 * 3 + 1];
        const operation = data[i2 * 3 + 2];
        const nodeStr = `Operation #${idx}: Node${idxL} ${operation} Node${idxR}`;
        output.push(nodeStr);
    }
    for (let i3 = 0; i3 < num_out; i3++) {
        const ptr = data[i3 + num_mid * 3];
        const nodeStr = `Output #${i3}: Node${ptr}`;
        output.push(nodeStr);
    }
    return output.join("\n");
}
exports.default = cgpToHumanizedFull;
